import { object, string } from 'yup';
var LoginSchema = object().shape({
  email: string().required('You must enter a username'),
  password: string().required('You must enter a password')
});
export { LoginSchema };